import { TRoute } from "../../utils/routes";
import PartyPageHome from "./Page/Home";

const PartyRouter: TRoute[] = [
  {
    path: "/party",
    name: "party",
    title: "Party",
    component: PartyPageHome,
  },
];

export default PartyRouter;
